import * as Moment from 'dayjs';

export function setDetail () {
  const detailTableCols = [
    {
      title: '系统序列号',
      dataIndex: 'systemSerialNumber',
      key: 'systemSerialNumber',
      width: 140,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '商品图片',
      dataIndex: 'image',
      key: 'image',
      width: 120,
      ellipsis: true,
      scopedSlots: { customRender: 'imageList' },
    },
    {
      title: '商品编码',
      dataIndex: 'goodsCode',
      key: 'goodsCode',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '商品名称',
      dataIndex: 'goodsName',
      key: 'goodsName',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '规格',
      dataIndex: 'specification',
      key: 'specification',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '型号',
      dataIndex: 'model',
      key: 'model',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '品牌名称',
      dataIndex: 'brandName',
      key: 'brandName',
      width: 150,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '生产商',
      dataIndex: 'producer',
      key: 'producer',
      width: 150,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '厂家编码',
      dataIndex: 'factoryCode',
      key: 'factoryCode',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '生产日期',
      dataIndex: 'productionDate',
      key: 'productionDate',
      width: 160,
      ellipsis: true,
      customRender: text => {
        return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
      },
    },
    {
      title: '失效日期',
      dataIndex: 'expiryDate',
      key: 'expiryDate',
      width: 160,
      ellipsis: true,
      customRender: text => {
        return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
      },
    },
    {
      title: '入库批次',
      dataIndex: 'warehousingBatch',
      key: 'warehousingBatch',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '是否医疗件',
      dataIndex: 'isMedichair',
      key: 'isMedichair',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text === 1 ? '是' : text === 2 ? '否' : '';
      },
    },
    {
      title: '采购单价',
      dataIndex: 'purchPrice',
      key: 'purchPrice',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text === '' || text === null || text === undefined ? '--' : text.toLocaleString('en-US', { minimumFractionDigits: 2 });
      },
    },
    {
      title: '计量单位',
      dataIndex: 'unitOfMsment',
      key: 'unitOfMsment',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '注册证号',
      dataIndex: 'registrationNumber',
      key: 'registrationNumber',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
  ];

  return detailTableCols;
}
